<enterprise-button-toggle  [formControl]="NgControl.control"
                    [Appearance]="Appearance"
                    [Disabled]="Disabled"
                    [ErrorMessageOverride]="ErrorMessageOverride"
                    [Hidden]="Hidden"
                    [HideIfDisabled]="HideIfDisabled"
                    [Label]="Label"
                    [NeedsVerificationCallback]="NeedsVerificationCallback"
                    [PropertyTracker]="PropertyTracker"
                    [ReadOnly]="ReadOnly"
                    [ShowLabel]="ShowLabel"
                    [ToolTip]="ToolTip"
                    [ToggleOptions]="ToggleOptions"
                    (Change)="OnChange($event)"
                    [InputId]="InputId"
                    [InputName]="InputName">
</enterprise-button-toggle>
